// Prepara TUTTI i dati della giornata per l'uso offline del capocantiere (#16).
// Strategia: una chiamata aggregata (/offline/giorno) per lo snapshot in localStorage,
// più il "riscaldamento" della cache del Service Worker chiamando gli stessi endpoint GET
// che le pagine useranno offline (il SW li conserva con strategia NetworkFirst).
import dayjs from 'dayjs';
import {
  interventiService,
  clientiService,
  cantieriService,
  veicoliService,
  usersService,
  offlineDataService,
  timbratureService,
  presenzeService,
  rapportiniService,
} from '../services/api';

const STORAGE_KEY = 'offline_giornata';

export function getGiornataSalvata() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY));
  } catch {
    return null;
  }
}

export async function scaricaDatiGiornata(data, onProgress) {
  const giorno = data || dayjs().format('YYYY-MM-DD');
  const progress = (msg, pct) => { if (onProgress) onProgress(msg, pct); };

  progress('Scarico gli interventi del giorno…', 5);
  const dump = (await offlineDataService.getGiorno(giorno)).data;
  const interventi = dump.interventi || [];

  // Riscalda la cache SW con le liste di lookup usate dai form
  progress('Preparo clienti, cantieri e mezzi…', 20);
  await Promise.allSettled([
    interventiService.getAll(),
    clientiService.getAll(),
    cantieriService.getAll(),
    veicoliService.getAttivi(),
    usersService.getCapocantieri(),
    usersService.getTecnici(),
  ]);

  // Riscalda la cache per ogni intervento (timbrature/presenze/rapportino/task)
  let done = 0;
  for (const iv of interventi) {
    await Promise.allSettled([
      timbratureService.getByIntervento(iv.id),
      presenzeService.getByIntervento(iv.id),
      rapportiniService.getByIntervento(iv.id),
      iv.cantiere_id ? cantieriService.getTasks(iv.cantiere_id) : Promise.resolve(),
    ]);
    done += 1;
    progress(
      `Preparo gli interventi (${done}/${interventi.length})…`,
      20 + Math.round((done / Math.max(1, interventi.length)) * 75)
    );
  }

  const snapshot = { ...dump, scaricato_il: new Date().toISOString() };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(snapshot));
  } catch (e) {
    // Quota localStorage piena: lo snapshot è grande ma la cache SW è comunque calda
    console.warn('Impossibile salvare lo snapshot offline (quota):', e);
  }
  progress('Dati pronti per l’uso offline', 100);
  return snapshot;
}
